export default __webpack_public_path__ + "static/media/cern-semibold-italic.92eae8d3.ttf";